import { useDialog, AnchorButton, UL, H3, H5 } from '@wheely/ui-kit';
import { useContext } from 'react';
import { FormattedMessage } from 'react-intl';

import { IntlContext } from '@/i18n';
import { CountryCode } from '@/shared/models/country-code';

import s from './styles.module.css';

const BookAnAppointmentModal = ({ url1, url2 }: { url1: string; url2: string }) => {
  const { region } = useContext(IntlContext);

  if (region === CountryCode.GreatBritain) {
    return (
      <div className={s.bookAppointmentDialogBlock}>
        <div className={s.bookAppointmentDialogParagraph}>
          <H5 className={s.bookAppointmentDialogText}>
            <FormattedMessage
              defaultMessage="Book City Knowledge Test at the Wheely Academy in-person."
              id="onboarding_intro_city_test_book_in_person"
              description="GB Academy accreditation requirements description"
            />
          </H5>
        </div>
        <div className={s.bookAppointmentDialogParagraph}>
          <H5 className={s.bookAppointmentDialogText}>
            <FormattedMessage
              defaultMessage="After successfully passing City Knowledge test our team will book you for the next available accreditation slot."
              id="onboarding_intro_city_test_description_1"
              description="GB Academy accreditation requirements description"
            />
          </H5>
        </div>
        <div className={s.bookAppointmentDialogParagraph}>
          <H5 className={s.bookAppointmentDialogText}>
            <FormattedMessage
              defaultMessage="Please make sure that you arrive in full attire on the day of the test, as well as to the accreditation."
              id="onboarding_intro_city_test_description_2"
              description="GB Academy accreditation requirements description"
            />
          </H5>
        </div>
        <AnchorButton href={url1} fill={true} intent="none" target="_blank" rel="noreferrer">
          <FormattedMessage
            defaultMessage="Book City Knowledge Test"
            id="onboarding_intro_city_test_book"
            description="Book City Knowledge Test button"
          />
        </AnchorButton>
      </div>
    );
  }

  if (region === CountryCode.UnitedStates) {
    return (
      <div className={s.bookAppointmentDialogBlock}>
        <div className={s.bookAppointmentDialogParagraph}>
          <H5 className={s.bookAppointmentDialogText}>
            <FormattedMessage
              defaultMessage="The 2-day in-person Wheely Academy course includes:"
              id="onboarding_academy_us_modal_title"
              description="US academy booking modal title"
            />
          </H5>
        </div>
        <div className={s.bookAppointmentDialogParagraph}>
          <H5 className={s.bookAppointmentDialogText}>
            <FormattedMessage
              defaultMessage="Day 1: Classroom-based learning session on everything you need to know to become a Wheely Chauffeur."
              id="EFDqP6"
              description="Academy Day 1 description"
            />
          </H5>
        </div>
        <div className={s.bookAppointmentDialogParagraph}>
          <H5 className={s.bookAppointmentDialogText}>
            <FormattedMessage
              defaultMessage="Day 2: Interactive chauffeur, vehicle & journey assessments to qualify as a Wheely Chauffeur."
              id="0YJewn"
              description="Academy Day 2 description"
            />
          </H5>
        </div>
        <div className={s.bookAppointmentDialogParagraph}>
          <H5 className={s.bookAppointmentDialogText}>
            <FormattedMessage
              defaultMessage="Please attend with all documents uploaded, Online Learning completed and in full Dress Code."
              id="onboarding_academy_us_modal_requirements"
              description="US academy booking modal requirements"
            />
          </H5>
        </div>
        <AnchorButton href={url1} fill={true} intent="none" target="_blank" rel="noreferrer">
          <FormattedMessage
            defaultMessage="Book"
            id="onboarding_academy_us_modal_book"
            description="US academy booking modal book button"
          />
        </AnchorButton>
      </div>
    );
  }

  if (region === CountryCode.France) {
    return (
      <div className={s.bookAppointmentDialogBlock}>
        <div className={s.bookAppointmentDialogParagraph}>
          <FormattedMessage
            defaultMessage="Visit the Wheely Academy to take part in a pre-assessment session. This session evaluates:"
            id="onboarding_academy_fr_modal_paragraph_1"
            description="Book an appointment modal description paragraph (FR case)"
          />

          <UL>
            <FormattedMessage
              defaultMessage="your professional knowledge; and"
              id="onboarding_academy_fr_modal_paragraph_1_bullet_1"
              description="Book an appointment modal description paragraph bullet (FR case)"
              tagName="li"
            />
            <FormattedMessage
              defaultMessage="your willingness to enter into a partnership with Wheely, serving a prestigious clientele."
              id="onboarding_academy_fr_modal_paragraph_1_bullet_2"
              description="Book an appointment modal description paragraph bullet (FR case)"
              tagName="li"
            />
          </UL>
        </div>

        <AnchorButton href={url1} fill={true} intent="none" target="_blank" rel="noreferrer">
          <FormattedMessage
            defaultMessage="Book Your Spot"
            id="onboarding_academy_fr_modal_cta"
            description="Book an appointment modal CTA button (FR case)"
          />
        </AnchorButton>
      </div>
    );
  }

  return (
    <div>
      <div className={s.bookAppointmentDialogBlock}>
        <div className={s.bookAppointmentDialogParagraph}>
          <H5 className={s.bookAppointmentDialogText}>
            <FormattedMessage
              defaultMessage="Day 1: Classroom-based learning session on everything you need to know to become a Wheely Chauffeur"
              id="EFDqP6"
              description="Academy Day 1 description"
            />
          </H5>
          <br />
          <H5 className={s.bookAppointmentDialogText}>
            <FormattedMessage
              defaultMessage="Requirements: Documents uploaded, Online learning completed & Full Dress Code"
              id="IxmVNx"
              description="Academy Day 1 requirements"
            />
          </H5>
        </div>
        <AnchorButton href={url1} fill={true} intent="none" target="_blank" rel="noreferrer">
          <FormattedMessage
            defaultMessage="Book Day 1"
            id="ycUk0h"
            description="Academy Day 1 button"
          />
        </AnchorButton>
      </div>
      <div className={s.bookAppointmentDialogBlock}>
        <div className={s.bookAppointmentDialogParagraph}>
          <H5 className={s.bookAppointmentDialogText}>
            <FormattedMessage
              defaultMessage="Day 2: Interactive chauffeur, vehicle & journey assessments to qualify as a Wheely Chauffeur"
              id="0YJewn"
              description="Academy Day 2 description"
            />
          </H5>
          <br />
          <H5 className={s.bookAppointmentDialogText}>
            <FormattedMessage
              defaultMessage="Requirements: Vehicle prepared to Wheely Standards & Full Dress Code"
              id="OAgYRP"
              description="Academy Day 2 requirements"
            />
          </H5>
        </div>
        <AnchorButton href={url2} fill={true} intent="none" target="_blank" rel="noreferrer">
          <FormattedMessage
            defaultMessage="Book Day 2"
            id="aJs6z1"
            description="Academy Day 2 button"
          />
        </AnchorButton>
      </div>
    </div>
  );
};

const useBookAnAppointmentModal = () => {
  const { openDialog } = useDialog();

  const openBookAnAppointmentModal = ({
    dayOneLink,
    dayTwoLink,
    region,
  }: {
    region: string;
    dayOneLink: string;
    dayTwoLink: string;
  }) => {
    let title = (
      <FormattedMessage defaultMessage="Select the day" id="k4bnb0" description="Dialog title" />
    );

    if (region === CountryCode.GreatBritain) {
      title = (
        <FormattedMessage
          defaultMessage="Enrol to Wheely Academy"
          id="g4cGRL"
          description="Dialog title"
        />
      );
    }

    if (region === CountryCode.France) {
      title = (
        <FormattedMessage
          defaultMessage="Select Your Time Slot"
          id="onboarding_academy_fr_modal_title"
          description="Book an appointment modal title (FR case)"
        />
      );
    }

    openDialog(() => <BookAnAppointmentModal url1={dayOneLink} url2={dayTwoLink} />, {
      title: <H3>{title}</H3>,
      className: s.bookAppointmentDialog,
      titleClassName: s.bookAppointmentDialogTitle,
      bodyClassName: s.bookAppointmentDialogBody,
    });
  };

  return { openModal: openBookAnAppointmentModal };
};

export { useBookAnAppointmentModal };
